import {
  PremiumsEasyPayChangeBody,
  PremiumsEasyPayEnrollmentStatus,
  PremiumsEasyPayStartBody,
  PremiumsEasyPaySummary
} from '@cms-max/medicare-api-sdk'
import { rest } from 'msw'
import { isTest } from 'test-utils/isTest'
import { coreApiBase } from 'test-utils/mock-api'

export const easyPayResponse: PremiumsEasyPaySummary = {
  isEligible: true,
  isEnrolled: true,
  accountNumberMasked: '************01234',
  status: PremiumsEasyPayEnrollmentStatus.Active
}

const completedAt = '2023-04-01T15:30:00.000Z'

export function fetchEasyPaySummarySuccess (
  overrides: Partial<PremiumsEasyPaySummary> = {}
) {
  return rest.get(`${coreApiBase}/premiums/easy-pay`, (req, res, ctx) => {
    return res(
      ctx.delay(isTest ? 0 : undefined),
      ctx.status(200),
      ctx.json({
        ...easyPayResponse,
        ...overrides
      })
    )
  })
}

export function fetchEasyPaySummaryLoading () {
  return rest.get(`${coreApiBase}/premiums/easy-pay`, (req, res, ctx) => {
    return res(ctx.delay('infinite'), ctx.status(200), ctx.json({}))
  })
}

export function fetchEasyPaySummaryFailure () {
  return rest.get(`${coreApiBase}/premiums/easy-pay`, (req, res, ctx) => {
    return res(
      ctx.delay(isTest ? 0 : undefined),
      ctx.status(500),
      ctx.json({})
    )
  })
}

export function startEasyPaySuccess () {
  return rest.post<PremiumsEasyPayStartBody, { completedAt: string }>(
    `${coreApiBase}/premiums/easy-pay/start`,
    (req, res, ctx) => {
      const statusCode = req.headers.get('Accept-Language') ? 200 : 500
      return res(
        ctx.delay(isTest ? 0 : undefined),
        ctx.status(statusCode),
        ctx.json({ completedAt })
      )
    }
  )
}

export function startEasyPayFailure (
  type: keyof typeof updateEasyPayFailureTypes
) {
  return rest.post(
    `${coreApiBase}/premiums/easy-pay/start`,
    (req, res, ctx) => {
      return res(
        ctx.delay(isTest ? 0 : undefined),
        ctx.status(updateEasyPayFailureTypes[type]),
        ctx.json({})
      )
    }
  )
}

export function updateEasyPaySuccess () {
  return rest.post<PremiumsEasyPayChangeBody, { completedAt: string }>(
    `${coreApiBase}/premiums/easy-pay/change`,
    (req, res, ctx) => {
      const statusCode = req.headers.get('Accept-Language') ? 200 : 500
      return res(
        ctx.delay(isTest ? 0 : undefined),
        ctx.status(statusCode),
        ctx.json({ completedAt })
      )
    }
  )
}

export function updateEasyPayLoading () {
  return rest.post<PremiumsEasyPayChangeBody, { completedAt: string }>(
    `${coreApiBase}/premiums/easy-pay/change`,
    (req, res, ctx) => {
      return res(
        ctx.delay('infinite'),
        ctx.status(200),
        ctx.json({ completedAt })
      )
    }
  )
}

const updateEasyPayFailureTypes = {
  conflict: 409,
  validation: 422,
  server: 500,
  unavailable: 503
} as const
export function updateEasyPayFailure (
  type: keyof typeof updateEasyPayFailureTypes
) {
  return rest.post(
    `${coreApiBase}/premiums/easy-pay/change`,
    (req, res, ctx) => {
      return res(
        ctx.delay(isTest ? 0 : undefined),
        ctx.status(updateEasyPayFailureTypes[type]),
        ctx.json({})
      )
    }
  )
}

export function stopEasyPaySuccess () {
  return rest.get<PremiumsEasyPayStartBody, { completedAt: string }>(
    `${coreApiBase}/premiums/easy-pay/stop`,
    (req, res, ctx) => {
      const statusCode = req.headers.get('Accept-Language') ? 200 : 500
      return res(
        ctx.delay(isTest ? 0 : undefined),
        ctx.status(statusCode),
        ctx.json({ completedAt })
      )
    }
  )
}

export function stopEasyPayFailure (
  type: keyof typeof updateEasyPayFailureTypes
) {
  return rest.get(`${coreApiBase}/premiums/easy-pay/stop`, (req, res, ctx) => {
    return res(
      ctx.delay(isTest ? 0 : undefined),
      ctx.status(updateEasyPayFailureTypes[type]),
      ctx.json({})
    )
  })
}
